import React, { useEffect } from 'react';
import { LocalSessionKey } from '../burger-king-lib/constants/app-constants';
import { trackUserEvents } from '../../analatics/moengage/userEvents';
import { customMoengageNames } from '../../analatics/moengage/constants';

export default function useMoengageEvents() {
  useEffect(() => {
    function handler(event) {
      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_SHOWN' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }

      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_CLICKED' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }

      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_DISMISSED' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }

      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_AUTO_DISMISS' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }
    }

    window.addEventListener('MOE_AUTOMATED_EVENTS', handler);

    const navEntry = performance.getEntriesByType('navigation')[0];

    let isFreshOpen = false;
    let isReload = false;

    if (navEntry) {
      isFreshOpen = navEntry.type === 'navigate';
      isReload = navEntry.type === 'reload';
    }

    const sessionFlag = sessionStorage.getItem(
      LocalSessionKey.IS_APP_NEWLY_LAUNCHED
    );

    if (!sessionFlag) {
      isFreshOpen = true;
    } else if (!isReload) {
      isReload = true;
    }

    sessionStorage.setItem(LocalSessionKey.IS_APP_NEWLY_LAUNCHED, 'true');
    const userId = localStorage.getItem(LocalSessionKey.USER_ID);
    const phoneNumber = localStorage.getItem(LocalSessionKey.USER_DATA);
    if (
      (isFreshOpen || isReload) &&
      typeof userId === 'string' &&
      typeof phoneNumber === 'string' &&
      !!userId &&
      !!phoneNumber
    ) {
      trackUserEvents(customMoengageNames.userId, userId, phoneNumber.trim());
    }

    return () => {
      window.removeEventListener('MOE_AUTOMATED_EVENTS', handler);
    };
  }, []);
}
